/* @flow strict */

import moment from 'moment-timezone/moment-timezone.js';

moment.tz.add('America/Los_Angeles|PST PDT|80 70|0101|1Lzm0 1zb0 Op0');

const lockTransferTicket = (element: {}, id: string, key: string): boolean => {
  const TZ = 'America/Los_Angeles';
  const now = moment.tz(TZ);
  const from = moment.tz('2020-11-04 00:00', TZ);
  const to = moment.tz('2020-11-15 12:00', TZ);

  if (element[key] !== id) {
    return true;
  }

  return now.isBefore(from) || now.isAfter(to);
};

export default lockTransferTicket;
